import { z } from 'zod';
import { COMMISSION_TYPES } from '../constants/commission';

const requiredAmount = z
  .string()
  .min(1, 'CPA Amount is required.')
  .refine((value) => Number.isFinite(Number(value)) && Number(value) >= 0, 'CPA Amount must be zero or greater.');

const requiredDays = z
  .string()
  .min(1, 'Hold Period is required.')
  .refine(
    (value) => Number.isInteger(Number(value)) && Number(value) >= 0,
    'Hold Period must be a whole number of days.'
  );

const optionalWagering = (label: string) =>
  z
    .string()
    .refine(
      (value) => value === '' || (Number.isFinite(Number(value)) && Number(value) >= 0),
      `${label} must be zero or greater.`
    );

export const affiliateCommissionSchema = z.object({
  affiliateCommissionType: z.literal(COMMISSION_TYPES.CPA),
  cpaAmount: requiredAmount,
  holdPeriod: requiredDays,
  minSportsbookWagering: optionalWagering('Minimum Sportsbook Wagering'),
  minCasinoWagering: optionalWagering('Minimum Casino Wagering'),
  newPlayer: z.boolean(),
  kyc: z.boolean(),
});
